import { render, staticRenderFns } from "./ExpiredInviteLink.vue?vue&type=template&id=5f7cdc5c&scoped=true"
import script from "./ExpiredInviteLink.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpiredInviteLink.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ExpiredInviteLink.vue?vue&type=style&index=0&id=5f7cdc5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7cdc5c",
  null
  
)

export default component.exports